import { ProcessStep } from "../types";
import { computeMachineCost } from "./computeMachineCost";
import { OptimizedMachineTimes, withOptimizedMachineTimes } from "./computeOptimizedMachineTimes";

export type MachineTimeGainLine = {
  processStep: ProcessStep;
  quantity: number;
  quantityInAssembly: number | null;
  reworkRatio: number | null;
};

export const sumMachineTimesOptimizationGain = ({
  lines,
  optimizedMachineTimes,
}: {
  lines: MachineTimeGainLine[];
  optimizedMachineTimes: OptimizedMachineTimes;
}): number =>
  lines.reduce((gain, line) => {
    return computeMachineTimesOptimizationLineGain(line, optimizedMachineTimes) + gain;
  }, 0);

const computeMachineTimesOptimizationLineGain = (
  line: MachineTimeGainLine,
  optimizedMachineTimes: OptimizedMachineTimes,
): number => {
  const costParams = {
    quantity: line.quantity,
    quantityInAssembly: line.quantityInAssembly,
    reworkRatio: line.reworkRatio,
  };
  const originalCost = computeMachineCost({
    ...costParams,
    processStep: line.processStep,
  }).machineCost;
  const updatedCost = computeMachineCost({
    ...costParams,
    processStep: withOptimizedMachineTimes(line.processStep, optimizedMachineTimes),
  }).machineCost;

  return originalCost - updatedCost;
};
